<div class="page-container">
  <div class="relative page-edge-cut">
    <div class="form-card">
      <form [formGroup]="form">
        @if (step == 1) {
        <section>
          <h1 class="section-heading">
            {{ "MEMBERSHIP.SELECT_MEMBERSHIP_TITLE" | translate }}
          </h1>
          <div class="fields-container">
            <app-active-memberships
              [memberships]="memberships"
              [membershipId]="membershipId"
              (selectMembership)="setSelectedMemberShip($event)"
            ></app-active-memberships>

            @if (!membershipId && selectMembershipError) {
            <app-validation-message
              [type]="'error'"
              [content]="{
                title: 'VALIDATION_MSG.ERROR' | translate,
                message: 'VALIDATION_MSG.SELECT_MEMBERSHIP' | translate
              }"
              [showbutton]="false"
            ></app-validation-message>
            }
            <!-- End Membership -->
            @if (step == 1) {
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-5">
              <app-button
                classesName="btn-edge-cut btn-primary-big mt-6"
                [disabled]="form.get('membershipId')!.invalid"
                [label]="'BUTTONS.CONTINUE' | translate"
                (onBtnClick)="proceed()"
              ></app-button>
            </div>
            }
          </div>
        </section>
        }
        <!-- sr deatil loader -->
        @if(loadingSrDeetail){
        <app-skeleton-loader
          [formLoader]="true"
          [noOfFields]="5"
        ></app-skeleton-loader>
        } @if (step >= 2 && form.controls) {

        <!-- Action for show notes -->
        @if (srNumber && srInprgoressAwating && !loadingSrDeetail) {
        <app-validation-message
          type="info"
          [content]="{
            title: 'SECTION_NOTES' | translate,
            message: 'SECTION_NOTES_DESCRIPTION' | translate
          }"
          [showbutton]="false"
          [buttonText]="'VIEW_NOTES' | translate"
          (onBtnClick)="showNotes = true"
        />
        }
        <section>
          <h1 class="section-heading">
            {{ "MEMBERSHIP.MEMBERSHIP_CANCELLATION" | translate }}
          </h1>
          <div class="fields-container">
            <div class="field-control">
              <app-option-field
                [label]="'MEMBERSHIP.CANCELLATION_REASON' | translate"
                [control]="form.get('cancellationReason')!"
                [lovType]="LookupKey.DC_MEM_CANCEL_REASON"
                (onSelectionChange)="onLovChange($event)"
              >
              </app-option-field>
            </div>
            <div class="field-control">
              <app-option-field
                [control]="form.get('cancellationLetter')"
                [label]="'MEMBERSHIP.CANCELLATION_LETTER_REQUIRED' | translate"
                [lovType]="LookupKey.DC_RESIDENT_OF_UAE"
              >
              </app-option-field>
            </div>
            <div class="field-control">
              <app-text-field
                type="big-text"
                [label]="'MEMBERSHIP.REASON_DESCRIPTION' | translate"
                [control]="form.get('cancellationReasonDescription')!"
                [maxlength]="30"
              >
              </app-text-field>
            </div>

            <div class="field-control">
              <app-text-field
                type="number"
                [label]="'MEMBERSHIP.SERVICES_BALANCE' | translate"
                [control]="form.get('serviceBalance')!"
              >
              </app-text-field>
            </div>
            @if(form.get('serviceBalance')?.value > 0){
              <div class="field-control">
                <app-option-field
                  [control]="form.get('bankName')"
                  [label]="'MEMBERSHIP.BANK_NAME' | translate"
                  [lovType]="LookupKey.XX_BANK_CODES"
                >
                </app-option-field>
              </div>

              <div class="field-control">
                <app-text-field
                  [label]="'MEMBERSHIP.ACCOUNT_HOLDER_NAME' | translate"
                  [control]="form.get('accountHolderName')!"
                >
                </app-text-field>
              </div>

              <div class="field-control">
                <app-text-field
                  [label]="'MEMBERSHIP.IBAN_NO' | translate"
                  [control]="form.get('IBANNo')!"
                  [maxlength]="34"
                >
                </app-text-field>
              </div>
            }
          </div>
        </section>
        } @if (step >= 3) {
        <section class="space-y-4">
          <h1 class="section-heading">
            {{ "MEMBERSHIP.UPLOAD_DOCUMENTS" | translate }}
          </h1>
          @if(documentLoader){
          <app-skeleton-loader
            [formLoader]="true"
            [noOfFields]="3"
          ></app-skeleton-loader>
          } @if(srFolder && !documentLoader){
          <div class="fields-container">
            @for (dt of srFolder.allowedDocumentTypes; track $index) {
            <div class="field-control">
              <app-file
                #fileCmp
                [title]="lang == 'en' ? dt.nameEn : dt.nameAr"
                [documentType]="dt.nameEn"
                (folderMissing)="openFolder()"
                (onUploadRemove)="handelFileEvent($event, dt.nameEn)"
                [showAction]="showActions"
                [folder]="srFolder"
                [documentServiceType]="documentServiceType.MEMBERSHIP"
              ></app-file>
            </div>
            }
          </div>
          }
        </section>
        } @if(technicalErrorMsg){
        <app-validation-message
          [type]="'error'"
          [content]="{
            title: 'VALIDATION_MSG.ERROR' | translate,
            message: 'TOAST_MESSAGES.TECHNICAL_ERROR' | translate
          }"
          [showbutton]="false"
        ></app-validation-message>
        }
        <!-- Next and Close Button -->
        @if (step > 1) {
        <div class="btn-section buttons-group">
          @if (showActions && !formSubmitLoader) {
          <app-button
            [type]="'button'"
            [label]="'BUTTONS.NEXT' | translate"
            classesName="btn-edge-cut  btn-width-auto"
            (onBtnClick)="nextStep()"
          />

          <app-button
            [type]="'button'"
            [label]="'BUTTONS.SAVE_CLOSE' | translate"
            classesName="card-edge-cut-white !btn-edge-cut btn-width-auto"
            (onBtnClick)="saveAndClose()"
          />
          } @if (formSubmitLoader) {
          <app-button
            type="button"
            classesName="btn-edge-cut btn-width-auto"
            [label]="'PLEASE_WAIT' | translate"
            [disabled]="true"
          ></app-button>
          }
        </div>
        }
      </form>
    </div>
  </div>

  <!-- Form Completion Progress -->
  <div>
    <app-service-progress
      [serviceName]="'MEMBERSHIP_CANCELLATION' | translate"
      [completePercentage]="formProgress"
    />
  </div>
</div>

@if (successModal) {
<app-sr-submit-success-modal
  [srNumber]="srNumber"
  (onClose)="closeSuccessModal()"
></app-sr-submit-success-modal>
} @if (pendingSrNumber) {
<app-pending-sr-modal
  [srNumber]="pendingSrNumber"
  (onClose)="closependingSrModal()"
/>
}

<!-- notes modal -->
@if(showNotes) {
<app-notes
  [srNumber]="srNumber"
  [allowSubmit]="true"
  (onClose)="showNotes = false"
></app-notes>
}
